// type : b-icon
export default {
    "sap-connector": "server",
    "mail-connector": "inbox-fill",
    "api-connector": "server",
}